<template>
    <kgr-lightbox
        :value="show"
        :headline="$t('Hinweis')"
        scrollable
        @post-input="$emit('close')"
    >
        <div
            v-if="invoicesWithAlreadySentEmail.length > 0"
            class="kgr-text"
        >
            {{ $t('An {amount} Mitglieder wurde die Rechnung bereits per E-Mail verschickt.', { amount: invoicesWithAlreadySentEmail.length }) }}
            {{ $t('Möchtest du diese Zahlungsdokumente wirklich erneut per Mail versenden?') }}
        </div>
        <div
            v-else
            class="kgr-text"
        >
            {{ $t('Möchtest du diese Zahlungsdokumente per Mail versenden?') }}
        </div>
        <template #footer>
            <button
                class="kgr-button"
                @click="$emit('close')"
            >
                {{ $t('cancel') }}
            </button>
            <button
                class="kgr-button kgr-button--accent"
                @click="$emit('confirm')"
            >
                {{ $t('Ok') }}
            </button>
        </template>
    </kgr-lightbox>
</template>

<script>
import Lightbox from '../../common/modal/Lightbox.vue';

export default {
    components: {
        'kgr-lightbox': Lightbox,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        invoices: {
            type: Array,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
    computed: {
        invoicesWithAlreadySentEmail() {
            return this.invoices.filter((invoice) => invoice.pdfLastSendAsEmail !== null);
        },
    },
};
</script>
